(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsEveryHourController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'LangService', 'NotificationFactory', 'SectorService'];

  function reports ($scope, $http, $timeout, ngTableParams, LangService, NotificationFactory, SectorService) {
    var vm = this;

    LangService
      .getPageLabels({ 'page': 'menu.reports.hour' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
        vm.types = [
          {
            'id': 'operator',
            'name': vm.labels.operator
          },
          {
            'id': 'firstAtt',
            'name': vm.labels.operatorFirstAtt
          },
          {
            'id': 'sector',
            'name': vm.labels.sector
          },
          {
            'id': 'status',
            'name': vm.labels.status
          }
        ];
        vm.current_type = vm.types[0];
        reload();
      });

    SectorService.sectors_with_trashed()
      .$promise
      .then(function (data) {
        vm.sectors_with_trashed = data;
      })
      .catch(function (data) {
        NotificationService.errorHandler(data, $scope.labels.errorLoadDepart);
      });

    	$scope.vm = vm;
    Chart.defaults.global.legend.display = true;
    vm.loading = true;

    vm.changeType = function (type) {
      vm.current_type = type;
      reload();
    }

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      sector_id: ''
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.table = new ngTableParams({
      page: 1,
      total: 50
    }, {
      getData: function ($defer, params) {
        params.total(gdata.total);
        $defer.resolve(gdata.result);
      }
    });

    var gdata = {};
    function reload () {
      vm.loading = true;
      gdata = {};
      $http.get(apiUrl + '/reports/every-hour', {
        // params: params.url()
        params: {
          type: vm.current_type.id,
          filters: vm.filters
        }
      })
        .then(function ({ data }) {
          // params.total(data.total);
          // $defer.resolve(data.result);
          if (data.success === false) {
            notifSet.addNotification({
              title: 'Erro!',
              content: data.error_message,
              color: 'alert',
              autoclose: 3000
            });
            $scope.labels = null;
            $scope.series = null;
            $scope.data = null;

            vm.table_trs = null;

            // gdata = null;

            vm.table.reload();
            vm.loading = false;

            return;
          }

          vm.date = data.date;
          var series = [];
          var all = [];
          var labels = [];
          var tr_labels = [];

          for (var operator in data.result) {
            series.push(operator);
            var current = [];
            labels = [];
            tr_labels = [];

            for (var hour in data.result[operator]) {
              labels.push(hour);
              tr_labels.push(hour);
              current.push(data.result[operator][hour]);
            }

            all.push(current);
          }

          /* TOTALS */
          // var totals = {};
          // var grand_total = 0;
          // for (var key in all) {
          //     var total = 0;
          //     for (var hora in all[key]) {
          //         var qty = parseInt(all[key][hora]);
          //         if (typeof totals[hora] == undefined) {
          //             totals[hora] = 0;
          //         }
          //         totals[hora] += qty;
          //         grand_total += qty;
          //         total += qty;
          //     }
          //     all[key].push(total); // push Total to row
          //     console.log(all[key]);
          // }
          // totals['total'] = grand_total;
          // for (var i in totals) {
          //     current.push(totals[i]);
          // }
          // all.push(current);
          /* TOTALS */

          // foreach ($data as $key => $horas) {
          //     $total = 0;
          //     foreach ($horas as $hora => $qty) {
          //         if (!isSet($totals[$hora])) {
          //             $totals[$hora] = 0;
          //         }
          //     }
          // }
          // $data['totais'] = $totals;

          $scope.labels = labels;
          $scope.series = series;
          $scope.data = all;

          var totals = {};
          var grand_total = 0;
          for (var key in data.result) {
            var total = 0;
            for (var hora in data.result[key]) {
              var qty = parseInt(data.result[key][hora]);
              if (typeof totals[hora] === 'undefined') {
                totals[hora] = 0;
              }
              total += qty;
              totals[hora] += qty;
              grand_total += qty;
            }
            data.result[key]['total'] = total;
          }
          totals['total'] = grand_total;
          data.result['Total'] = totals;

          tr_labels.push(vm.labels.total);
          vm.table_trs = tr_labels;

          gdata = data;

          vm.table.reload();
          vm.loading = false;
        }, function ({ data }) { console.log(data) });
    }

    vm.reload = reload;

    $scope.options = {
      maintainAspectRatio: true,
      responsive: true,
      datasetFill: true,
      bezierCurve: true
    };

    vm.downloadCsv = function () {
      var csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += vm.current_type.name;
      for (var i in vm.table_trs) {
        csvContent += ',' + vm.table_trs[i];
      }
      csvContent += '\n';
      // ,Resposta Recebida em,Resposta
      for (var operator in gdata.result) {
        var arr = [
          operator
        ];
        for (var j in gdata.result[operator]) {
          arr.push(gdata.result[operator][j]);
        }
        csvContent += arr.join(',');
        csvContent += '\n';
      }
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'download-rel.csv');
      document.body.appendChild(link);
      link.click();
    };

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });
  }
})();
